import { z } from 'zod';
import { UuidString } from '../../primitives.js';

/**
 * work-tasks-performance B10/B11 — контракты счётчиков и серверной сортировки.
 *
 * ЗАЧЕМ СЧЁТЧИКИ ОТДЕЛЬНОЙ РУЧКОЙ. До фазы D числа в hero-чипах и заголовках
 * групп считались на клиенте по всей выдаче — потому что выдача и была полной
 * (до 2000 строк). Как только таблица начинает качать страницу, эти числа
 * становятся числами страницы, то есть уверенным враньём: «Просрочено 12» при
 * сорока просроченных. Считать их обязан сервер — одним агрегатом по тем же
 * фильтрам, что и список.
 */

/** Ключи сортировки списка — whitelist. Строка-имя-колонки сюда не попадает. */
export const TaskSortKey = z.enum([
  'title',
  'state',
  'priority',
  'due_date',
  'start_date',
  'created_at',
  'updated_at',
  'progress',
  'sequence_id',
  'sort_order',
]);
export type TaskSortKey = z.infer<typeof TaskSortKey>;

/**
 * Счётчики hero-чипов. Определения ЗЕРКАЛЯТ клиентские (`_auth.work-tasks.index.tsx`):
 * иначе число на чипе и состав по клику на него разойдутся, а это ровно тот класс
 * «уверенно и неверно», против которого делается пак.
 */
export const TaskHeroCounts = z.object({
  /** Срок прошёл и задача не завершена. */
  overdue: z.number().int().nonnegative(),
  /** Срок в ближайшие 7 дней включительно, задача не завершена. */
  due_soon: z.number().int().nonnegative(),
  /** Ни одного ответственного. */
  unassigned: z.number().int().nonnegative(),
  /** Ни начала, ни срока. */
  no_date: z.number().int().nonnegative(),
  /** Текущий пользователь среди ответственных. */
  mine: z.number().int().nonnegative(),
});
export type TaskHeroCounts = z.infer<typeof TaskHeroCounts>;

export const TaskCountsResponse = z.object({
  /** Всего задач под теми же фильтрами, что у списка. */
  total: z.number().int().nonnegative(),
  /** По группам статуса (`backlog`/`started`/…): ключ — код группы, не текст. */
  by_state_group: z.record(z.string(), z.number().int().nonnegative()),
  /**
   * По проектам — grain по ЧЛЕНСТВАМ `[Б13]`: задача в трёх проектах даёт +1
   * каждому, и сумма по проектам законно больше `total`.
   */
  by_project: z.record(UuidString, z.number().int().nonnegative()),
  /**
   * По ГЛАВНОМУ проекту задачи (`tasks.project_id`), grain — задача.
   *
   * Зачем второй разрез. Заголовки групп таблицы считает `groupByProject`, а он
   * кладёт задачу под ОДИН проект — главный. Membership-grain для них больше на
   * величину вторичных членств: на локальном сиде это 3 проекта из 26, и один из
   * них таблица не создаёт вовсе (его единственная задача главная в другом).
   * Заголовок «316» над 315 строками — ровно то «уверенно и неверно», против
   * которого делается пак, поэтому у заголовков свой разрез, совпадающий с их
   * собственным правилом группировки.
   */
  by_primary_project: z.record(UuidString, z.number().int().nonnegative()),
  hero: TaskHeroCounts,
});
export type TaskCountsResponse = z.infer<typeof TaskCountsResponse>;
